var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 500,
    height: 500,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#69d7f9;}.cls-2{fill:none;stroke:#3a00ba;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.87,13s6.71,3.92,6.71,9.49v9.16c0,2.29-3.27,4.75-5.89,4.75,0,0,3,1,3,3.43H58.2l.49-3.11h2.46V23.13S59.67,13,48.87,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.38,40s5.89,8.67,5.89,18.32v-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.6,80.24s.49,3.11,7.69,3.11,10-1.8,10-1.8L63,85.31l-9.66,1.31s-7,1.48-7.85-2.61Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "58.68 36.4 58.68 40.26 41.32 40.26 41.32 36.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.27,24.58a11.27,11.27,0,0,0-22.54,0v4.2l.32,7.62H61l.32-7.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.61,
    y: 34.83,
    width: 3.59,
    height: 3.59,
    rx: 1.79,
    transform: "translate(36.78 110.03) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "72.11 36.63 63.89 36.63 61.27 34.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.61,
    y: 18.42,
    width: 3.59,
    height: 3.59,
    rx: 1.79,
    transform: "translate(93.62 -53.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "71.78 20.22 63.89 20.22 61.27 22.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 66.92,
    y: 26.63,
    width: 3.59,
    height: 3.59,
    rx: 1.79,
    transform: "translate(97.13 -40.29) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 67.2,
    y1: 28.42,
    x2: 61.27,
    y2: 28.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.8,
    y: 34.83,
    width: 3.59,
    height: 3.59,
    rx: 1.79,
    transform: "translate(-10.03 63.22) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "27.93 36.63 36.11 36.63 38.73 34.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.8,
    y: 18.42,
    width: 3.59,
    height: 3.59,
    rx: 1.79,
    transform: "translate(46.81 -6.38) rotate(90)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "28.09 20.22 36.11 20.22 38.73 22.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.49,
    y: 26.63,
    width: 3.59,
    height: 3.59,
    rx: 1.79,
    transform: "translate(59.71 -2.87) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.84,
    y1: 28.42,
    x2: 38.73,
    y2: 28.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.39,85.64l-8.88,1H49.14a3.51,3.51,0,0,1-3.52-3.51V40.38h8.79V69.56a3.52,3.52,0,0,0,3,3.47l6,.91Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 57.86,
    y1: 77.46,
    x2: 63.25,
    y2: 77.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 57.86,
    y1: 81.83,
    x2: 63.25,
    y2: 81.83
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyLine);
export default __webpack_public_path__ + "static/media/Key_Line.031fa345c659f287f72c628f3fc57c0d.svg";
export { ForwardRef as ReactComponent };